import { Icon } from "./styles";

interface ComponentProps {
  icon: string;
  color?: string;
  size?: string;
  onClick?: () => any;
}

const defaultValues = {
  size: "24px",
};

const Component = (props: ComponentProps) => {
  const values = { ...defaultValues, ...props };
  return (
    <Icon onClick={() => !!props.onClick && props.onClick()} {...values} />
  );
};

export default Component;
